export default __webpack_public_path__ + "static/402-a73dab690290378462a6409f0ae55ed7.gif";